import React, { useEffect, useState, ReactNode, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty, isNumber, round } from 'lodash';
import { init } from 'echarts';

import Color from '@tool/color';
import moIndustry from '../../store/industry';
import Empty from '@/component/empty';

interface IProps {}
interface IState {}

const TalentChart = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const talentRef = useRef<any>(null);
  let chart: any = null;
  const { talentList } = moIndustry;

  const render = () => {
    if (chart) chart.dispose();
    chart = init(talentRef.current);
    const option = {
      series: [
        {
          type: 'gauge',
          radius: '90%',
          axisLine: {
            lineStyle: {
              width: 5,
              color: [
                [0.3333, Color.success],
                [0.6666, Color.secondary],
                [1, Color.red],
              ],
            },
          },
          splitNumber: 3,
          pointer: {
            icon: 'circle',
            length: 8,
            width: 8,
            offsetCenter: [0, '-86%'],
            itemStyle: {
              color: 'transparent',
              borderColor: Color.f7,
              borderWidth: 2,
              borderType: 'solid',
              borderCap: 'round',
              shadowColor: 'rgba(0, 0, 0, 0.5)',
              shadowBlur: 10,
            },
          },
          axisTick: {
            distance: -30,
            length: 5,
            lineStyle: {
              color: '#fff',
              width: 0,
            },
          },
          splitLine: {
            distance: -30,
            length: 32,

            lineStyle: {
              color: '#fff',
              width: 4,
            },
          },
          axisLabel: {
            show: false,
          },
          detail: {
            backgroundColor: Color.successColor(0.2),
            width: 30,
            lineHeight: 10,
            padding: 10,
            height: 30,
            borderRadius: 30,
            offsetCenter: [0, 0],
            formatter: function (value: any) {
              return `{value|${value ? value.toFixed(0) : ''}}\n{unit|${
                talentList?.recruit_rank?.amount ?
                  talentList?.recruit_rank?.amount.toLocaleString() :
                  ''
              }}`;
            },
            rich: {
              value: {
                fontSize: 24,
                fontWeight: 600,
                color: Color.success,
                fontFamily: 'Roboto',
              },
              unit: {
                fontSize: 12,
                color: Color.success,
                padding: [0, 0, -20, 0],
                fontFamily: 'Roboto',
              },
            },
          },
          data: [
            {
              value: talentList?.recruit_rank?.amount_rank,
              name: '',
            },
          ],
        },
      ],
    };
    chart.setOption(option, true);
  };

  useEffect(() => {
    if (!isEmpty(talentList)){
      render();
    }
    window.addEventListener('resize', render);
    return () => {
      window.removeEventListener('resize', render);
    };
  }, [talentList]);

  return (<section>
    { !isEmpty(talentList) ? <section className="talent-chart-warp">
      <section className="talent-chart" ref={talentRef} />
      <p>
        <span>两年内最低 0</span>
        <span>100 两年内最高</span>
      </p>
    </section> : <Empty height="auto" />}
  </section>
  );
};

export default observer(TalentChart);
